import React from "react";

export const TOPBAR_HEIGHT = 64;

export default function TopNavbar({ user, onLogout }) {
  return (
    <header
      style={{
        height: TOPBAR_HEIGHT,
        minHeight: TOPBAR_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px 0 12px",
        background: "linear-gradient(135deg, #0d9488, #14b8a6)",
        boxShadow: "0 4px 14px rgba(13, 148, 136, 0.25)",
        position: "sticky",
        top: 0,
        zIndex: 50,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          fontSize: 20,
          fontWeight: 800,
          color: "#ffffff",
          letterSpacing: "0.2px",
        }}
      >
        Softvolute Buildcon LLP
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: "#ffffff" }}>
          Welcome, {user?.name}
        </span>

        <button
          type="button"
          onClick={onLogout}
          style={{
            border: "none",
            borderRadius: 999,
            padding: "8px 18px",
            background: "#ffffff",
            color: "#0d9488",
            fontSize: 13,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>
    </header>
  );
}
